import React from 'react';
import { Box, Typography } from '@mui/material';
import Link from 'next/link';
// styles
import styles from './styles';

export interface LibSitemapGeneralProps {
  listData?: {
    sitemapLinks?: {
      id?: string;
      label?: string;
      url?: string;
    }[];
    sitemapSections?: {
      id?: string;
      title?: string;
      sitemapLinks?: {
        id?: string;
        label?: string;
        url?: string;
        subSitemapLinks?: {
          id?: string;
          label?: string;
          url?: string;
          subSitemapLinks?: {
            id?: string;
            label?: string;
            url?: string;
          }[];
        }[];
      }[];
    }[];
  };
}

function LibSitemapGeneral({ listData = {} }: LibSitemapGeneralProps) {
  return (
    <Box component="section" sx={styles.container}>
      <Box sx={styles.internalBox}>
        <Box>
          {listData?.sitemapLinks?.map((item) => (
            <Box sx={styles.subtitle} key={item.label}>
              <Box sx={styles.bulletPoint} />
              <Link prefetch={false} href={item?.url}>
                <Typography variant="subtitle2" component="span">
                  {item?.label}
                </Typography>
              </Link>
            </Box>
          ))}
        </Box>

        {listData?.sitemapSections?.map((itemX) => (
          <Box sx={styles.subsection} key={itemX.title}>
            <Typography variant="h2" sx={styles.title}>
              {itemX.title}
            </Typography>

            {/* Second Lvl */}
            {itemX?.sitemapLinks.map((itemY) => (
              <>
                <Box sx={styles.subtitle}>
                  <Box sx={styles.bulletPoint} />
                  <Link prefetch={false} href={itemY?.url}>
                    <Typography variant="subtitle2" component="span">
                      {itemY?.label}
                    </Typography>
                  </Link>
                </Box>

                {/* Third Lvl */}
                {itemY?.subSitemapLinks.map((itemZ) => (
                  <>
                    <Box sx={styles.tertiarytitle} key={itemZ.label}>
                      <Box sx={styles.bulletPoint} />
                      <Link prefetch={false} href={itemZ?.url}>
                        <Typography variant="subtitle2" component="span">
                          {itemZ?.label}
                        </Typography>
                      </Link>
                    </Box>

                    {itemZ?.subSitemapLinks?.map((item) => (
                      <Box sx={styles.fourthtitle} key={item.label}>
                        <Box sx={styles.bulletPoint} />
                        <Link prefetch={false} href={item?.url}>
                          <Typography variant="subtitle2" component="span">
                            {item?.label}
                          </Typography>
                        </Link>
                      </Box>
                    ))}
                  </>
                ))}
              </>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export const SitemapGeneral = React.memo(LibSitemapGeneral);

export default SitemapGeneral;
